import { useEffect, useState } from 'react'

export const useMobileDesign = () => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 767)
        }

        window.addEventListener('resize', handleResize)

        handleResize()

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return isMobile
}

export default useMobileDesign